"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallInfoFactory = void 0;
const ErrorStackParser = __importStar(require("error-stack-parser"));
const StackGenerator = __importStar(require("stack-generator"));
class CallInfoFactory {
    create() {
        try {
            throw new Error();
        }
        catch (err) {
            return this.getCallInfo(err);
        }
    }
    getCallInfo(stackError) {
        try {
            const stackFrames = this.getStackTraceSync(stackError);
            const frame = stackFrames[stackFrames.length - 1];
            return {
                file: '/' + frame.fileName.substring(frame.fileName.lastIndexOf('/') + 1),
                line: frame.lineNumber,
                method: frame.functionName,
            };
        }
        catch (err) {
            return {
                file: undefined,
                line: undefined,
                method: undefined,
            };
        }
    }
    getStackTraceSync(err) {
        var _a;
        const operaSourceLoc = 'opera#sourceloc' in err ? err['opera#sourceloc'] : undefined;
        const isShapedLikeParsableError = (_a = err.stack) !== null && _a !== void 0 ? _a : operaSourceLoc;
        return isShapedLikeParsableError ? ErrorStackParser.parse(err) : StackGenerator.backtrace();
    }
}
exports.CallInfoFactory = CallInfoFactory;
